<template>
    <CodiceFeanorView tool-module="certificate" />
</template>

<script setup>
import CodiceFeanorView from "../CodiceFeanorView.vue";
</script>
